// extracted by mini-css-extract-plugin
export var error = "Error-module--error--060ad";
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var xsBreak = "480";